import React from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";
import pointNpi from '../static/images/pointer-logo.svg';
import nic from '../static/images/nic.svg';


const { MarkerWithLabel } = require("react-google-maps/lib/components/addons/MarkerWithLabel");
const mapStyle = [
  {
    "featureType": "administrative.country",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#5a1c00"
      },
      {
        "weight": 2
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#c1c1c1"
      }
    ]
  }
]

const MyMapComponent = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap defaultZoom={16} defaultCenter={{ lat: 48.717084, lng: 21.245454 }} defaultOptions={{ styles: mapStyle }}>
              <MarkerWithLabel
         position={{ lat: 48.717084, lng: 21.248254, }}
         labelAnchor={{ lat: 48.717084, lng: 21.250454, }}
         labelStyle={{fontSize: "20px", color: "#444"}}
         icon={{
           url: nic,
         }}
       >
         <div>Nová Polhora Invest, s.r.o.</div>
         </MarkerWithLabel>
     
      {props.isMarkerShown && (
        <Marker position={{ lat: 48.717084, lng: 21.250454 }}
                icon={{
                  url: pointNpi,
                }} />
      )}
    </GoogleMap>
  ))
);

export default MyMapComponent;
